/* HausofWheels mobile purchase bar.
 * Rebind the sticky action whenever Shopify replaces its canonical product form.
 * The canonical form is the only element that adds products to cart.
 */
(() => {
  if (window.HausMobileBuybar?.initialized) return;

  const instances = new WeakMap();

  function refresh(root, incomingProduct) {
    if (!root) return;

    const previous = instances.get(root);
    if (previous) {
      previous.visibilityObserver?.disconnect();
      previous.stateObserver?.disconnect();
      window.removeEventListener('resize', previous.sync);
      window.removeEventListener('pageshow', previous.sync);
      instances.delete(root);
    }

    if (incomingProduct) {
      const currentBar = root.querySelector('.how-mobile-buybar');
      const nextBar = incomingProduct.querySelector('.how-mobile-buybar');

      if (nextBar && currentBar) {
        currentBar.replaceWith(nextBar);
      } else if (nextBar) {
        root.querySelector('product-form')?.insertAdjacentElement('afterend', nextBar);
      } else {
        currentBar?.remove();
      }
    }

    const bar = root.querySelector('.how-mobile-buybar');
    if (!bar) return;

    const enquiry = bar.hasAttribute('data-how-mobile-enquirybar');
    const original = root.querySelector(enquiry ? '.how-product-enquiry-cta' : '.product-form__submit');
    const action = bar.querySelector('.how-mobile-buybar__button');

    if (!original || !action) {
      bar.hidden = true;
      return;
    }

    let originalVisible = true;
    const sync = () => {
      if (!bar.isConnected || !original.isConnected) return;

      const disabled = !enquiry && (
        original.disabled || original.getAttribute('aria-disabled') === 'true'
      );
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const show = isMobile && !disabled && !originalVisible &&
        original.getBoundingClientRect().bottom <= 0;

      if (enquiry) {
        const href = original.getAttribute('href');
        if (href) action.setAttribute('href', href);
      } else {
        const label = original.querySelector('span')?.textContent?.trim();
        const mirrorLabel = action.querySelector('span');
        if (label && mirrorLabel) mirrorLabel.textContent = label;
        action.disabled = disabled;
      }

      bar.hidden = disabled;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      action.tabIndex = show ? 0 : -1;
    };

    if (!enquiry) {
      action.addEventListener('click', () => {
        if (!original.isConnected || original.disabled ||
            original.getAttribute('aria-disabled') === 'true') return;
        original.click();
      });
    }

    const visibilityObserver = new IntersectionObserver((entries) => {
      originalVisible = entries[0]?.isIntersecting ?? true;
      sync();
    }, { threshold: 0.2 });
    visibilityObserver.observe(original);

    const stateObserver = new MutationObserver(sync);
    stateObserver.observe(original, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });

    window.addEventListener('resize', sync, { passive: true });
    window.addEventListener('pageshow', sync, { passive: true });

    instances.set(root, { visibilityObserver, stateObserver, sync });
    bar.hidden = false;
    sync();
  }

  window.HausMobileBuybar = { initialized: true, refresh };

  function initialize() {
    document.querySelectorAll('product-info').forEach((root) => refresh(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
